module.exports = __webpack_public_path__ + "static/media/endTrip.62662b3b.svg";